<template>
    <div class="homepage mx-auto">
        <browse :listing_type="'company-listings'"></browse>
    </div>
</template>

<script>
// import Browse from "./browse";
export default {
    name: 'homepage',
    // components: {Browse},
    data() {
        return {
            applicantName: '',
            applicantEmail: '',
            applicantPhone: '',
            window: {
                width: 0,
                height: 0
            },
            show_bridge: true,
            searchtext: null,
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            let _self = this;
            _self.isLoading = true;
            let data = {
                name: _self.applicantName,
                email: _self.applicantEmail,
                phone: _self.applicantPhone,
            };
            axios.post('/api/join-our-team', data)
                .then(function (response) {
                    _self.isLoading = false;
                    Toast.fire({
                        icon: 'success',
                        title: "Message Sent!"
                    });

                }).catch(function (error) {
                    console.log(error);
                    _self.isLoading = false;
                }
            ).finally(() => {
                _self.name = '';
                _self.email = '';
                _self.phone = '';

                _self.$refs['modal-1'].hide()
            });
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        search() {
            let _self = this;

            let data = {
                searchString: _self.searchtext,
            };

            window.location.href = '/browse?search=' + _self.searchtext;
        },
    },
    mounted() {
    },
    computed: {
        window_width() {
            return this.window.width;
        },
    }
}

</script>

<style lang="scss">
.bridge {
    z-index: 1;
}

.body {
    background-color: #007b
}

@media (max-width: 979px) {
    .logo {
        display: none;
    }
}

.logo {
    position: absolute;
    top: 25px;
    left: 25px;
    z-index: 2;
}

.lato {
    font-family: "Lato", sans-serif
}

.dropdown {
    font-size: large;
}

.outer-div {
    position: absolute;
    top: 30px;
    right: 0;
    left: 0;
    z-index: 13;
}

.inner-div {
    margin: 0 auto;
    margin-top: 200px;
    width: 500px;
}

.b-jumbotron {
    background-color: #125697 !important;

    .font-family {
        font-family: "Lato", sans-serif !important;
    }
}

</style>
